import { render } from "./TeamLogo.vue?vue&type=template&id=4b2639bb&scoped=true"
import script from "./TeamLogo.vue?vue&type=script&lang=js"
export * from "./TeamLogo.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4b2639bb"

export default script